import 'core-js';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import microApp from '@micro-zoe/micro-app';
import MircoAppLoading from './MicroAppLoading';

console.log('mirco entry');

let hideLoading = () => {};

microApp.start({
  lifeCycles: {
    mounted () {
      hideLoading();
    },
    error () {
      console.log('error');
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('microRoot') as HTMLElement
);


function MainApp() {
  const [loading, setLoading] = React.useState(true);
  hideLoading = () => setLoading(false);
  return (
    <>
      {loading ? <MircoAppLoading /> : null}
      <micro-app
        name='micro'
        url={window?.microAppConfig?.url}
        baseroute={window?.microAppConfig?.baseroute}
      />
    </>
  );
}

root.render(
  <MainApp/>
);
